import { Component } from '@angular/core';
import { IonicPage, AlertController, NavController, NavParams, ViewController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Items } from '../../providers/providers';

/**
 * Generated class for the AddNotePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-add-note',
  templateUrl: 'add-note.html',
})
export class AddNotePage {

  note: { title: string, body: string, client_id: string} = {
    title: 'New Note',
    body: '',
    client_id: ''
  };

  submitClient: boolean = false;
  isReadyToSave: boolean;
  id: any = '';

  form: FormGroup;

  constructor(public navCtrl: NavController, public alertCtrl: AlertController, public viewCtrl: ViewController, public items: Items, formBuilder: FormBuilder, public navParams: NavParams) {
    if (this.navParams.data.note) {
      this.note.body = this.navParams.data.note.body;
      this.note.title = this.navParams.data.note.title;
      this.id = this.navParams.data.note.id;
    }
    this.form = formBuilder.group({
      title: [this.note.title],
      body: [this.note.body, Validators.required]
    });

    // Watch the form for changes, and
    this.form.valueChanges.subscribe((v) => {
      this.isReadyToSave = this.form.valid;
    });
  }

  ionViewDidLoad() {
    //console.log('inside ionViewDidLoad AddNotePage');
    
  }

  cancel() {
    var ret = {
      action: 'cancel',
      item: null
    };
    this.viewCtrl.dismiss(ret);
  }

  /**
   * The user is done and wants to create the item, so return it
   * back to the presenter.
   */
  done() {
    if (!this.form.valid) { return; }
    var ret = {
      action: 'save',
      item: this.form.value
    };
    this.viewCtrl.dismiss(ret);
  }

  // delete() {
  //   if (this.id) {
  //     let seq = this.items.deleteNote(this.id).share();
  //     seq
  //       .map(res => res.json().data.note)
  //       .subscribe(res => {
  //         this.viewCtrl.dismiss();
  //       }, err => {
  //         console.error('ERROR', err);
  //       });
  //   }
  // }

  delete() {
    let prompt = this.alertCtrl.create({
      message: "Are you sure you want to delete this client note?",
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Yes',
          handler: data => {
            this.items.deleteNote(this.id).subscribe((resp) => {
              if (resp) {
                var ret = {
                  action: 'delete',
                  item: null
                };
                this.viewCtrl.dismiss(ret);
              }
            }, (err) => {

            })

          }
        }
      ]
    });
    prompt.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-note/add-note.ts